<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
        >
            <b-sidebar id="add_new_product1" aria-labelledby="sidebar-no-header-title" no-header backdrop width="50%" style="direction:ltr;padding:5px;" right title="اضافة منتج" shadow >
                <template #default="{ hide }" >
                <div class="m-1 text-start" style="direction:rtl;margin:5px;">
                    <div style="width:130px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                    <span>{{lang.add_edit_product}}</span>
                    </div>
                    <div @click="hide" id="hidecrmprodaddeditView" style="text-align:center;width:100px;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                    <span>{{lang.close}}</span>
                </div>
                </div>
                <v-divider></v-divider>
                <v-row style="direction:rtl;margin:5px;" class="m-2">
                    <v-col cols="12" md="3" sm="12">
                        <label>{{lang.item_code}}</label>
                        <b-form-input class="inborder"
                            v-model="product.item_code"
                            @change="getItem()"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <label>{{lang.vendor_code}}</label>
                        <b-form-input class="inborder"
                            v-model="product.vendor_code"
                            ></b-form-input>
                    </v-col>
                    <v-col cols="12" md="3" sm="12" class="select_box">
                        <label>{{lang.is_finalProduct}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.is_finalProduct"
                            :options="isFinal"
                            ></b-form-select>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="3" sm="12" class="select_box">
                        <label>{{lang.is_saleable}}</label>
                        <b-input-group>

                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.saleable"
                            :options="saleAbles"
                            >
                            </b-form-select>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.product_namear}}</label>
                        <b-form-input class="inborder"
                            v-model="product.item_namear"
                            ></b-form-input>
                    </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <label>{{lang.product_nameen}}</label>
                    <b-form-input class="inborder"
                        v-model="product.item_nameen"
                    ></b-form-input>
                  </v-col>

                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.product_category}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.catid"
                            :options="categories"
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.product_type}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.item_type"
                            :options="productstype"
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.main_unit}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important"
                            v-model="product.main_unit"
                            :options="mainUnits"
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </v-col>
                </v-row>
                <v-row style="direction:rtl;padding:2px;">
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.taxes}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important;background:blue !important;"
                            v-model="product.taxesArrays"
                            :options="taxesIList"
                            multiple
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>

                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.stores}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important;background:blue !important;"
                            v-model="product.storesids_array"
                            :options="storesIList"
                            multiple
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>

                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{lang.branches}}</label>
                        <b-input-group>
                            <b-form-select class="selborder"
                            style="width:200px !important;background:blue !important;"
                            v-model="product.branches_array"
                            :options="branchesIList"
                            multiple
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down" style="z-index:"></i>
                            </b-input-group-append>
                        </b-input-group>

                    </v-col>
                </v-row>
                <v-row style="direction:rtl;padding:2px;">
                    <v-col cols="12" v-if="product.saleable == 1">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="backBlack">{{lang.unit_name}}</th>
                                    <th class="backBlack">{{lang.sale_price}}</th>
                                    <th class="backBlack">{{ lang.minimum_salse_price }}</th>
                                    <th class="backBlack">{{ lang.maximum_salse_price }}</th>
                                    <th class="backBlack">{{lang.default_cost}}</th>
                                    <th v-if="product.id != 0"  class="backBlack">{{lang.update}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in unitsPrices[product.main_unit]" :key="index">
                                    <td>{{ item[`name${lang.langname}`] }}</td>
                                    <td><b-form-input class="inborder" v-model="unitsPrices[product.main_unit][index].default_price" /></td>
                                    <td><b-form-input class="inborder" v-model="unitsPrices[product.main_unit][index].min_price" /></td>
                                    <td><b-form-input class="inborder" v-model="unitsPrices[product.main_unit][index].max_price" /></td>
                                    <td><b-form-input class="inborder" v-model="unitsPrices[product.main_unit][index].cost" /></td>
                                    <td v-if="product.id != 0" @click="updateThis(unitsPrices[product.main_unit][index])" style="background:blue !important;width:70px;color:#fff !important;border-bottom: 1px solid #fff !important;text-align:center;">{{ lang.update }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>

                </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" @click="addItem()" variant="success" class="ma-2" style="width:100px;">{{lang.save}}</b-button>
                    </div>
                </template>
            </b-sidebar>
            <vue-snotify></vue-snotify>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';
export default{
    data() {
        return {
            isEdit: 0,
            branch: {},
            taxes: [],
            item_code: '',
            productsname: [],
            product: {
                id: 0,
                item_code: '',
                vendor_code: '',
                item_namear: '',
                item_nameen: '',
                main_unit: 1,
                catid: 1,
                type: 1,
                taxids: '',
                storesids: '1,2',
                storesids_array: {1:true, 2:true},
                taxesArrays: {VAT: true},
                item_type: 1,
                is_finalProduct: 1,
                status: 1,
                saleable: 1,
                branchesIds: [],
                branches_array: [],
            },
            extra: {
                brand: 0,
            },
            productcats: [],
            alternatives: [],
            deftype: 1,
            units: [],
            finalsProd: [],
            priceLists: [],
            rawMaterials: [],
            taxesList: [],
            storesList: [],
            unitsPrices: {},
            branchesLists: [],
            product_settings: []
        }
    },
    methods: {
        getProductSettings()
        {
            this.product_settings = [];
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getExtraSettings');
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[table]',"inventory_products")
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                this.product_settings = response.data.results.data;

            });
        },
        addToBranches(id){
            let addMe = true;
            for(let i=0;i<this.product.branchesIds.length;i++){
                if(this.branch[`branch_`+id] === false){
                    if(id == this.product.branchesIds[i]){
                        this.product.branchesIds.splice(i,1);
                        addMe = false;
                    }
                }
            }
            if(addMe){
                this.product.branchesIds.push(id);
            }
        },
        updateThis(){
            const message = this.lang.product_update_save_note;
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.close,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
            return false;
        },
        getUnits(){
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getUnits');
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[units]',0)
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    this.units = response.data.results.data;
                }
            })
        },
        doconsole() {
            // // console.log("holaaaa",this.product);
        },
        changeTax(){
            let tax = '';
            if(this.product.isvat === true){
                tax = '1'
            }
            if(this.product.issmoke === true){
                // if(tax == '1'){
                //     tax = '1,2'
                //     tax = '1,2'
                // }else{
                //     tax = '2';
                // }
            }
            this.product.taxs = tax;
            this.CalckValues(1);
        },
        CalckValues(i){
            // // console.log(this.product);
            if(i==1){
                let vat = 0;
                let smoke = 0;
                if(this.product.isvat === true){
                    let t = this.$calcVat(this.product.price,2);
                    vat = t.vat;
                }
                // if(this.product.issmoke == true){
                //     smoke = this.product.price;
                // }
                this.product.taxprice = parseFloat(this.product.price) + parseFloat(vat) + parseFloat(smoke);

            }else{
                let value = 100;
                let vat = 0;
                let smoke = 0;
                if(this.product.isvat == true){
                    value = parseFloat(value) + 15;
                }
                // if(this.product.issmoke == true){
                //     value = parseFloat(value) + 100;
                // }
                const price = this.$calcTax(this.product.taxprice,value)

                this.product.price = price;
            }
        },
        getCats(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getPCatsList");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',"all0");
            post.append('data[lang]',"ar");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            .then((res) => {
                const p = res.data;
                let t = [];
                if(typeof p.results !== 'undefined' && typeof p.results.data !== 'undefined'){
                    if(p.results.data.length != 0){
                        for(let i=0;i<p.results.data.length;i++){
                            t.push({
                                text: p.results.data[i].namear,
                                value: p.results.data[i].id
                            });
                            // if(i == 0){
                                this.product.catid = p.results.data[i].id
                                this.deftype = p.results.data[i].id
                            // }
                        }
                    }
                }
                this.productcats = t;
            });
        },
        resetAll(){

            this.product = {
                id: 0,
                item_code: '',
                vendor_code: '',
                item_namear: '',
                item_nameen: '',
                main_unit: 1,
                catid: 1,
                type: 1,
                taxids: '',
                storesids: '1,2',
                storesids_array: [],
                taxesArrays: [],
                item_type: 1,
                is_finalProduct: 1,
                status: 1,
                saleable: 1,
                branchesIds: [],
                branches_array: [],
            }
            this.unitsPrices = {}
            this.getTaxes();

        },
        getItem() {
            // // console.log("I am resting");
            const itemcode = this.product.item_code;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getItemBycode");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[item_code]",itemcode);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                if(this.isEdit == 0) {
                    if(typeof res.results.data.id !== 'undefined' && res.results.data.length != 0){
                        this.product.item_code = '';
                        let message = "الصنف موجود مسبقا .. يرجى اضافة صنف اخر";
                        this.$snotify.error(message, 'تنبيه', {
                            timeout: 1000000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            position: SnotifyPosition.centerCenter,
                            buttons: [
                                {
                                    text: this.$parent.lang.close,
                                    action: (toast) => {
                                        this.$snotify.remove(toast.id);
                                    }
                                },
                            ]
                        });

                        return false;
                    }
                    return false;
                }
                    this.product = {
                        id: res.results.data.id,
                        item_code: res.results.data.item_code,
                        vendor_code: res.results.data.vendor_code,
                        item_namear: res.results.data.item_namear,
                        item_nameen: res.results.data.item_nameen,
                        main_unit: res.results.data.main_unit,
                        catid: res.results.data.catid,
                        type: res.results.data.type,
                        taxids: res.results.data.taxes,
                        storesids: '1,2',
                        storesids_array: [1,2],
                        taxesArrays: [1],
                        item_type: res.results.data.item_type,
                        is_finalProduct: 1,
                        status: 1,
                        saleable: 1,
                        branchesIds: [1,2,3,4,5,6,7,8],
                        branches_array: [1,2,3,4,5,6,7,8],
                    }
                    this.unitsPrices = res.results.unitsPrices

            });
        },
        getAlternative(){
            const itemcode = this.item_code;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getItemBycode");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[itemcode]",itemcode);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                // // console.log(res);
                this.alternatives.push({
                    item_code: res.results.data.results[0].itemcode,
                    name: res.results.data.results[0].name,
                    price: res.results.data.results[0].price,
                    qty: res.results.data.results[0].qty,
                    cost: res.results.data.results[0].cost,
                });
                this.item_code = '';
            });
        },
        getTaxes(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","taxesList");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[all]","1");
            post.append("data[item_code]",this.product.item_code);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    this.taxesList = response.data.results.data
                    this.storesList = response.data.results.storesList
                    this.branchesLists = response.data.results.branchesLists
                    this.unitsPrices = response.data.results.unitsPrices

                    for(let i=0;i<response.data.results.branchesLists;i++){
                        this.branch[`branch_`+response.data.results.branchesLists[i].id] = false;
                    }

                }
            });
        },
        getProducts(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getallproducts");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[all]","1");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                // // console.log(res);
                if(res.results.data.length > 0){
                    for(let i=0;i<res.results.data.length;i++){
                        this.productsname.push(res.results.data[i])
                    }
                }
            });
        },
        addProd() {
            if(this.product.nameen == '' && this.product.name == ''){
                let message = "يرجى اضافة الاسم العربي للصنف";
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.invoice.payment.cash = this.full_ftotal
                return false;
            }
            else if(this.product.nameen != '' && this.product.name == ''){
                this.product.name = this.product.nameen
            }
            else if(this.product.name != '' && this.product.nameen == ''){
                this.product.nameen = this.product.name
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type" , "addNewProduct");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[item_code]",this.product.item_code);

            post.append("data[item_code]",this.product.item_code);
            post.append("data[name]",this.product.name);
            post.append("data[nameen]",this.product.nameen);
            post.append("data[qty]",this.product.qty);
            post.append("data[price]",this.product.price);
            post.append("data[taxprice]",this.product.taxprice);
            post.append("data[type]",this.product.type);
            post.append("data[cost]",this.product.cost);
            post.append("data[catid]",this.product.catid);
            post.append("data[isvat]",this.product.isvat);
            post.append("data[issmoke]",this.product.issmoke);
            post.append("data[issmoke]",false);
            post.append("data[taxes]",this.product.taxes);
            post.append("data[product_type]",this.product.product_type);
            for(let i=0;i<this.alternatives.length;i++){
                post.append("data[alternatives]["+i+"]",this.alternatives[i].item_code);
            }
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            )
            .then((response) => {
                let message = "تمت الاضافة - التعديل بنجاح";
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                const res = response.data;
                // // console.log("hello",res);
                document.getElementById('hidecrmprod').click();


            });
        },
        addItem(){

            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addProdItem");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[product]',JSON.stringify(this.product))
            post.append('data[salesTable]',JSON.stringify(this.unitsPrices[this.product.main_unit]))

            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                document.getElementById('hidecrmprodaddeditView').click();
                console.log([this.$parent])
                if (this.$parent && typeof this.$parent.getInvSettings === 'function') {
                    this.$parent.getInvSettings();
                }
                if (this.$parent && typeof this.$parent.getProducts === 'function') {
                    this.$parent.getProducts();
                }
                if (this.$parent && this.$parent.$parent && typeof this.$parent.$parent.getInvSettings === 'function') {
                    this.$parent.getInvSettings();
                }
                if (this.$parent && this.$parent.$parent && typeof this.$parent.$parent.getProducts === 'function') {
                    this.$parent.getProducts();
                }
                if (this.$parent && this. $parent.$parent && this.$parent.$parent.$parent && typeof this.$parent.$parent.$parent.getInvSettings === 'function') {
                    this.$parent.getInvSettings();
                }
                if (this.$parent && this. $parent.$parent && this.$parent && typeof this.$parent.$parent.$parent.getProducts === 'function') {
                    this.$parent.getProducts();
                }
                this.resetAll();
            })
        }
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        branchesIList: function (){
            let t = []
            for (let i=0 ; i < this.branchesLists.length ; i++){
                t.push(
                    {
                        text: this.branchesLists[i][`name_${this.lang.langname}`],
                        value: this.branchesLists[i].id,
                    }
                )
            }
            return t;
        },
        storesIList: function (){
            let t = []
            for (let i=0 ; i < this.storesList.length ; i++){
                t.push(
                    {
                        text: this.storesList[i][`name_${this.lang.langname}`],
                        value: this.storesList[i].id,
                    }
                )
            }
            return t;
        },
        taxesIList: function (){
            let t = []
            for (let i=0 ; i < this.taxesList.length ; i++){
                t.push(
                    {
                        text: this.taxesList[i][`name${this.lang.langname}`],
                        value: this.taxesList[i].id,
                    }
                )
            }
            return t;
        },
        categories: function(){
            let t = [];
            // console.log("categories",this.productcats);
            for(let i=0;i<this.productcats.length;i++){

                t.push({
                    text: this.productcats[i].text,
                    value: this.productcats[i].value
                })
            }
            return t;
        },
        isFinal: function(){
            let t = [];
            t.push({
                text: this.lang.final_product,
                value: 1,
            })
            t.push({
                text: this.lang.raw_material,
                value: 2,
            })
            if(this.$store.state.licenseType.manafactoring_enable){
                t.push({
                    text: this.lang.factory_item,
                    value: 3,
                })
            }

            return t;
        },
        saleAbles: function(){
            let t = [];
            t.push({
                text: this.lang.salesable,
                value: 1,
            })
            t.push({
                text: this.lang.none_salesable,
                value: 2,
            })

            return t;
        },
        productstype: function(){
            return [
                {text: this.lang.inventory_item,value: 1},
                {text: this.lang.service_item,value: 2},
            ]
        },
        mainUnits: function(){
            let t = [];
            for(let i=0;i<this.units.length;i++){
                if(this.units[i].type == 1){
                    t.push({
                        text: this.units[i][`name`+this.lang.langname],
                        value: this.units[i].id
                    })
                }

            }
            return t;
        }
    },
    created() {
        this.getProductSettings();
        this.getCats();
        this.getUnits();
    },
}
</script>

<style>
label{
    color:#000 !important;
}
.select_box{
  overflow: hidden;
  position: relative;
}
.select_box:after{
  width: 0;
  height: 0;
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  border-top: 6px solid #fff;
  position: absolute;
  top: 60%;
  left: 30px;
  content: "";
  z-index: 500;
 }
.select_box select{
  width: 220px;
  border: 0;
  position: relative;
  z-index: 99;
}
</style>